import { gql } from 'apollo-angular'

/**
 * Minimal set of fields required to show an edition in a article list view id
 * for link target, year and edition/version within the year for display
 */
export const EDITION_LINK_FIELDS = gql`
  fragment EditionLinkFields on Edition {
    id
    year
    edition_version
  }
`
